$(document).ready(function(){
  
      $(".filter-name").click(function(){
     	$(".mydropdown").not($(this).parent().next(".mydropdown")).slideUp();
    	$(this).parent().next(".mydropdown").slideToggle("fast");
  });

  
  
 	$('.sbo-detail-page #collaction_menu').addClass('in');
	$('.sbo-detail-page .collection-menu .category-head a').removeClass('collapsed');
  

  $('.collection_list_options').on('change',function(){

     var id = $(this).val();
         var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: {id:id},
      dataType: 'json',
     success: function(line_item) {
       if(typeof window.HSSLIDECART !== 'undefined') {
              HsCartDrawer.updateSlideCart();
        }
       
       //location.href ='/cart';
        $('.top-nav-link.cart__hover a')[0].click();
       //	fbq('track', 'AddToCart');
       
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        }
        else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
    jQuery.ajax(params);
	
  });
  
  
  
  
  /** COLLECTION MENU **/
  
  $(".submenu-caret").click(function(){
  	$(this).parent().find(".child").slideToggle(300);
    
  });
    $(".grand-submenu-caret").click(function(){
  	$(this).parent().find(".grandchild").slideToggle(300);
    
  });
  
  
  
  /** CHARACTER LIMIT FOR PRODUCT TITLE **/
$(".p-title-limit").text(function(index, currentText) {
	  if(currentText.length > 65)
      	return currentText.substr(0, 55) + '...';
	  else 
		return currentText;
  });

});




$(document).ready(function($){
    orientationChange();
});

function orientationChange() {
    if(window.addEventListener) {
        window.addEventListener("orientationchange", function() {
            location.reload();
        });
    }
}